module.exports = __webpack_public_path__ + "img/carrusel2.80c227f9.png";